import userReducer from "./userReducer";
import userImageReducer from "./userImageReducer";
import userNewImageReducer from "./userNewImageReducer";
import EHRReducer from "./EHRReducer";
import { combineReducers } from "redux";

const appReducers = combineReducers({
  currentUser: userReducer,
  userImage: userImageReducer,
  newUserImage: userNewImageReducer,
  ehr: EHRReducer,
});

export default appReducers;
